import React, { Component }  from 'react'
import { connect } from 'react-redux'

import CommonTable from 'components/Table'
import { Column } from 'react-virtualized'
import Badge from 'components/Badge'
import PropertyStatusIcon from './StatusIcon'
import {properties, owners} from 'selectors/entities'
import { propertiesTable } from 'selectors/propertiesTable'

const colors = {
	forRent: "#BA68C8",
	outOfServ: "#000",
	occupied: "#39cea8",
	noPaid: "red",
	retired: "#A0A0A0"
}

let select = (state, props) => ({
	properties: props.data || propertiesTable(state)
})

export class PropertiesTable extends Component{
	render(){
		let { props } = this
		let width = props.width || (window.innerWidth-60)
		let widthCategory = width>900 ? 3 : width>600 ? 2 : 1
		return(
			<CommonTable entity="property" showAll={props.showAll} data={props.properties}>
				<Column
				width={widthCategory==3?170:widthCategory==2?35:35}
				label={widthCategory==3 && "status"}
				dataKey='statusForSort'
				flexShrink={0}
				cellRenderer={
				  ({ rowData }) => (<div style={{position:"relative", top:"5px", left:"-8px"}}><PropertyStatusIcon id={rowData._id} />
				  		{widthCategory==3 && <span style={{
						  color:(rowData.dateTill)?colors.retired:(rowData.status.forRent=='For Rent')?colors.forRent:
							  (rowData.status.occupied=='Occupied')?
							  (rowData.status.paid)?colors.occupied:colors.noPaid:
							  (rowData.dateTill)?colors.retired:colors.outOfServ}}>
							  		{(rowData.dateTill)?"Retired":(rowData.status.forRent=='For Rent')?"For Rent":
		  							  (rowData.status.occupied=='Occupied')?"Occupied":"Not in Service"}
						</span>}</div>)
				}
				/>
				<Column
				  width={370}
				  label='Alias'
				  dataKey='alias'
				/>
				{widthCategory>2 && <Column
					width={500}
					label='address'
					dataKey='address'
				/>}
				{widthCategory>1 && <Column
				  width={250}
				  label='Owner'
				  dataKey='owner'
				/>}
				{widthCategory==3 &&
					<Column
					 width={50}
					 label={<i style={{fontSize:"22px"}} className="material-icons">attach_file</i>}
					 dataKey='attachments'
					 disableSort
					 cellRenderer={({ rowData }) =>
						 <Badge
							 style={{position:"relative", top:"8px", left:"-8px"}}
							 badgeContent={rowData.attachments ? rowData.attachments.length : "0"}
 							 primary={false}
 							 secondary={rowData.attachments ? !!rowData.attachments.length : false}
						 />
					 }
					 />
				}
				{widthCategory==3 &&
				  <Column
					width={50}
					label={<i style={{fontSize:"22px"}} className="material-icons">comment</i>}
					dataKey='comments'
					disableSort
					cellRenderer={({ rowData }) =>
						<Badge
							style={{position:"relative", top:"8px", left:"-8px"}}
							badgeContent={rowData.comments.length}
							primary={false}
							secondary={!!rowData.comments.length}
					    />
					}
				  />
				}
		  </CommonTable>
		)
	}
}
export default connect(select)(PropertiesTable)



// WEBPACK FOOTER //
// ./src/routes/manager/properties/Table.js